import { Route, Routes } from 'react-router-dom';

import { External } from 'src/components/External/External';
import Layout from 'src/components/Layout/Layout';
import { useConfig } from 'src/context/config';
import { useApplicationCorrelationId } from 'src/context/use-application-correlation-id';
import { useJobId } from 'src/context/useJobId';
import { useGetSignInUrl } from 'src/hooks/useGetSignInUrl';
import { FullScreenLoader } from 'src/ui/FullScreenLoader/FullScreenLoader';
import { SomethingWentWrong } from 'src/ui/SomethingWentWrong/SomethingWentWrong';
import { navigateToUrl } from 'src/utils';

import { ApplyPage } from '../ApplyPage/ApplyPage';

import { useInitApp } from './initialize-app';

const App = () => {
  const jobId = useJobId();
  const { config } = useConfig();
  const signInUrl = useGetSignInUrl();
  const { applicationCorrelationId, newApplication: isNewApplication } =
    useApplicationCorrelationId();

  const { loading, error, isAuth, isLinkOut } = useInitApp({
    jobId,
    config,
    applicationCorrelationId,
    isNewApplication,
  });

  if (loading) {
    return <FullScreenLoader />;
  }

  if (error) {
    return (
      <Layout>
        <SomethingWentWrong
          error={error}
          type="job-init-error"
          message="An error occurred when initialising job application"
          applicationCorrelationId={applicationCorrelationId}
          jobId={jobId}
        />
      </Layout>
    );
  }

  if (!isAuth) {
    navigateToUrl(signInUrl, true);

    return null;
  }

  if (isLinkOut) {
    return <External />;
  }

  return (
    <Routes>
      <Route path="/:lang?/job/:id/apply/*" element={<Layout />}>
        <Route path="*" element={<ApplyPage />} />
      </Route>
    </Routes>
  );
};

export default App;
